"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.luhnCheck = void 0;
var RADIX = 10;
var processDoubleDigit = function processDoubleDigit(digit) {
  return digit > 9 ? digit - 9 : digit;
};
var luhnCheck = exports.luhnCheck = function luhnCheck(num) {
  var reversedDigits = num.split('').reverse().map(function (digit) {
    return Number.parseInt(digit, RADIX);
  });
  var checkDigit = reversedDigits.shift();
  if (checkDigit === undefined) {
    return false;
  }
  var calculatedSum = reversedDigits.reduce(function (sum, digit, index) {
    var processedValue = index % 2 === 0 ? processDoubleDigit(digit * 2) : digit;
    return sum + processedValue;
  }, 0) + checkDigit;
  return calculatedSum % 10 === 0;
};